import axios from 'axios'


export default {
    namespaced: true,
    state: () => ({
        authenticated: false,
        user: {},
        token: null,
    }),
    mutations: {
        setAuthenticated(state, value) {
            state.authenticated = value;
        },
        setUser(state, value) {
            state.user = value || {};
        },
        setToken(state, value) {
            state.token = value;
        }
    },
    getters: {
        isAuthenticated: state => state.authenticated,
        getAuthenticated(state) {
            return state.authenticated;
        },
        getUser(state) {
            return state.user.full_name || '';
        },
        getRoles(state) {
            return state.user && Array.isArray(state.user.myRoles) ? state.user.myRoles : [];
        },
        isAdmin(state) {
            return (state.user && Array.isArray(state.user.myRoles) ? state.user.myRoles.length : 0) > 0;
        },
        getFullUser(state) {
            return state.user || {};
        },
        getToken(state) {
            return state.token;
        },
    },
    actions: {
        getUser({ commit }) {

            if (!localStorage.getItem('token')) {
                return Promise.resolve(false);
            }

            return axios
                .get("/user")
                .then(({ data }) => {
                    commit("setUser", data);
                    commit("setAuthenticated", true);

                    console.log('getUser', data);
                    window.Laravel.jsPermissions = data.myObjPermissions;
                    return data;
                })
                .catch((error) => {
                    // Reset auth state on failure
                    commit("setUser", {});
                    commit("setAuthenticated", false);
                    commit("setToken", null);
                    try {
                        localStorage.removeItem('token');
                        if (axios && axios.defaults && axios.defaults.headers && axios.defaults.headers.common) {
                            delete axios.defaults.headers.common['Authorization'];
                        }
                    } catch (e) {}
                    // Handle cases where error.response might not exist
                    return error?.response?.data || { message: 'Network error' };
                });
        },
        setToken({ commit }, value) {
            commit("setToken", value);
        },
        logout({ commit }) {
            return axios.get("/logout").then(() => {
                commit("setUser", { username: ''});
                commit("setAuthenticated", false);
                commit("setToken", null);
                try {
                    localStorage.removeItem('token');
                    if (axios && axios.defaults && axios.defaults.headers && axios.defaults.headers.common) {
                        delete axios.defaults.headers.common['Authorization'];
                    }
                } catch (e) {}
            }).catch(() => {
                // Ensure local cleanup even if server-side logout fails
                commit("setUser", { username: ''});
                commit("setAuthenticated", false);
                commit("setToken", null);
                try {
                    localStorage.removeItem('token');
                    if (axios && axios.defaults && axios.defaults.headers && axios.defaults.headers.common) {
                        delete axios.defaults.headers.common['Authorization'];
                    }
                } catch (e) {}
            });
        },
    }
};
